var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 52.8569C42.6236 52.8569 52.8572 42.6234 52.8572 29.9997C52.8572 17.3761 42.6236 7.14258 30 7.14258C17.3764 7.14258 7.14285 17.3761 7.14285 29.9997C7.14285 42.6234 17.3764 52.8569 30 52.8569Z",
    fill: "url(#paint0_radial_4760_27495)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30 52.8569C42.6236 52.8569 52.8572 42.6234 52.8572 29.9997C52.8572 17.3761 42.6236 7.14258 30 7.14258C17.3764 7.14258 7.14285 17.3761 7.14285 29.9997C7.14285 42.6234 17.3764 52.8569 30 52.8569Z",
    fill: "url(#paint1_radial_4760_27495)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5427 30.9716C23.7577 30.9716 24.7426 29.4814 24.7426 27.643C24.7426 25.8047 23.7577 24.3145 22.5427 24.3145C21.3276 24.3145 20.3426 25.8047 20.3426 27.643C20.3426 29.4814 21.3276 30.9716 22.5427 30.9716Z",
    fill: "url(#paint2_radial_4760_27495)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5427 25.4432C23.4855 25.4432 24.3141 26.2718 24.7426 27.486C24.7141 25.686 23.7427 24.2432 22.5427 24.2432C21.3427 24.2432 20.3712 25.686 20.3426 27.486C20.7712 26.2574 21.5998 25.4432 22.5427 25.4432Z",
    fill: "url(#paint3_linear_4760_27495)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4712 30.9716C38.6863 30.9716 39.6713 29.4814 39.6713 27.643C39.6713 25.8047 38.6863 24.3145 37.4712 24.3145C36.2562 24.3145 35.2712 25.8047 35.2712 27.643C35.2712 29.4814 36.2562 30.9716 37.4712 30.9716Z",
    fill: "url(#paint4_radial_4760_27495)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4712 25.5145C36.5284 25.5145 35.6998 26.3431 35.2712 27.5573C35.2998 25.7573 36.2712 24.3145 37.4712 24.3145C38.6712 24.3145 39.6427 25.7573 39.6713 27.5573C39.2427 26.3431 38.4141 25.5145 37.4712 25.5145Z",
    fill: "url(#paint5_linear_4760_27495)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0711 17.8853C35.1282 16.9711 36.1425 16.4567 37.8425 16.5425C39.2854 16.6282 42.4139 17.5997 44.4425 20.5282C44.8139 21.071 44.1854 21.3139 43.7996 20.9567C42.5139 19.7425 38.9996 18.071 36.1711 18.2139C35.0425 18.2853 35.0711 17.8853 35.0711 17.8853Z",
    fill: "url(#paint6_linear_4760_27495)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9284 17.8853C24.8713 16.9711 23.857 16.4567 22.157 16.5425C20.7142 16.6282 17.5856 17.5997 15.557 20.5282C15.1856 21.071 15.8141 21.3139 16.1999 20.9567C17.4856 19.7425 20.9999 18.071 23.8284 18.2139C24.957 18.2853 24.9284 17.8853 24.9284 17.8853Z",
    fill: "url(#paint7_linear_4760_27495)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45.5425C32.288 45.5425 34.1428 43.6877 34.1428 41.3997C34.1428 39.1117 32.288 37.2568 30 37.2568C27.712 37.2568 25.8571 39.1117 25.8571 41.3997C25.8571 43.6877 27.712 45.5425 30 45.5425Z",
    fill: "url(#paint8_radial_4760_27495)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 38.5426C31.7856 38.5426 33.3285 39.5425 34.1142 41.014C33.9142 38.914 32.1428 37.2568 29.9999 37.2568C27.8428 37.2568 26.0714 38.8997 25.8857 41.014C26.6714 39.5425 28.2142 38.5426 29.9999 38.5426Z",
    fill: "url(#paint9_linear_4760_27495)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4760_27495",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5071 20.73) scale(27.5742)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB92E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4760_27495",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5071 20.73) scale(21.6938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEA5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4760_27495",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8676 27.7276) rotate(73.8539) scale(3.22954 2.08946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4760_27495",
    x1: 22.5415,
    y1: 24.2951,
    x2: 22.5415,
    y2: 27.3972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4760_27495",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7934 27.7282) rotate(73.8539) scale(3.22954 2.08946)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4760_27495",
    x1: 37.4667,
    y1: 24.3767,
    x2: 37.4667,
    y2: 27.4787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4760_27495",
    x1: 39.7842,
    y1: 19.6697,
    x2: 39.9194,
    y2: 17.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4760_27495",
    x1: 20.2227,
    y1: 19.6696,
    x2: 20.0876,
    y2: 17.2649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4760_27495",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.7658 41.6482) rotate(73.8529) scale(5.01915 3.24687)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4760_27495",
    x1: 30.0043,
    y1: 35.313,
    x2: 30.0043,
    y2: 42.0603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShocked);
export default __webpack_public_path__ + "static/media/icon_shocked.a2825a44975fe1633bd57a12c647f608.svg";
export { ForwardRef as ReactComponent };